import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { Enum } from "./Enum.js";
/**
 * @name Result
 * @description
 * A Result maps to the Rust Result type, that can either wrap a success or error value
 */

export var Result = /*#__PURE__*/function (_Enum) {
  _inherits(Result, _Enum);

  var _super = _createSuper(Result);

  function Result(registry, Ok, Err, value) {
    _classCallCheck(this, Result);

    // NOTE This is order-dependent, Ok (with index 0) needs to be first
    // eslint-disable-next-line sort-keys
    return _super.call(this, registry, {
      Ok: Ok,
      Err: Err
    }, value);
  }

  _createClass(Result, [{
    key: "asErr",
    get:
    /**
     * @description Returns the wrapper Err value (if isErr)
     */
    function get() {
      assert(this.isErr, 'Cannot extract Err value from Ok result, check isErr first');
      return this.value;
    }
    /**
     * @deprecated Use asErr
     */

  }, {
    key: "asError",
    get: function get() {
      return this.asErr;
    }
    /**
     * @description Returns the wrapper Ok value (if isOk)
     */

  }, {
    key: "asOk",
    get: function get() {
      assert(this.isOk, 'Cannot extract Ok value from Err result, check isOk first');
      return this.value;
    }
    /**
     * @description Checks if the Result has no value
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.isOk && this.value.isEmpty;
    }
    /**
     * @description Checks if the Result wraps an Err value
     */

  }, {
    key: "isErr",
    get: function get() {
      return !this.isOk;
    }
    /**
     * @deprecated Use isErr
     */

  }, {
    key: "isError",
    get: function get() {
      return this.isErr;
    }
    /**
     * @description Checks if the Result wraps an Ok value
     */

  }, {
    key: "isOk",
    get: function get() {
      return this.index === 0;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      var Types = this._toRawStruct();

      return "Result<".concat(Types.Ok, ",").concat(Types.Err, ">");
    }
  }], [{
    key: "with",
    value: function _with(Types) {
      return /*#__PURE__*/function (_Result) {
        _inherits(_class, _Result);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Types.Ok, Types.Err, value);
        }

        return _createClass(_class);
      }(Result);
    }
  }]);

  return Result;
}(Enum);